import styled from '@xstyled/styled-components';
import { getContrastingColor } from '~/ui/buttons/helpers/getContrastingColor';

export const Button = styled.buttonBox<{
  backgroundColor?: string;
  contrasting?: boolean;
}>`
  border: none;
  padding: sm xl;
  border-radius: md;
  /* font-weight: bold; */
  background-color: accentDark;
  color: ${({ backgroundColor }) =>
    backgroundColor ? getContrastingColor(backgroundColor) : '#fff'};
  transition: 0.2s all linear;
  &:hover {
    ${props =>
      props.contrasting === false
        ? `opacity: 1; /* keep same, no contrast hover */`
        : `background-color: accentDark; opacity: 0.8;`}
  }
  &:disabled {
    background-color: greyLight;
    color: greyDark;
  }
  &.opened {
    background-color: #792bd5;
  }
`;
